export default from './Submit'


// WEBPACK FOOTER //
// ./src/components/Submit/index.js